import { createRouter, createWebHistory } from 'vue-router'
import Funkgeraet from '@/views/Funkgeraet.vue'
import Training from '@/views/Training.vue'
import NotFound from '@/views/NotFound.vue'
import { modes } from '@/data/Modes'
import Start from '@/views/Start.vue'
import Sprechregeln from '@/views/Sprechregeln.vue'
import SitzungLeiten from '@/views/SitzungLeiten.vue'
import SitzungBeitreten from '@/views/SitzungBeitreten.vue'
import { schuelerSitzung } from '@/logic/sitzungSchueler'

// Die Sitzungsansichten oeffnen nur mit einer Sitzung zum passenden Thema —
// sonst zurueck zum Beitreten.
const nurInSitzung = (thema) => () => {
  if (schuelerSitzung.daten?.konfiguration.thema !== thema) return { name: 'SitzungBeitreten' }
}

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start
  },

  {
    path: '/sprechregeln',
    name: 'Sprechregeln',
    component: Sprechregeln
  },

  {
    path: '/funkgeraet/:mode',
    name: 'Funkgeraet',
    component: Funkgeraet,
    props: true,
    beforeEnter: (to) => {
      const mode = modes.find(m => m.id === to.params.mode)
      // Der Sitzungsmodus hat seine eigene Route unter /sitzung/funk.
      if (!mode || mode.features.sitzung) return {name: 'Training'}
    }
  },

  {
    path: '/sitzung',
    name: 'SitzungBeitreten',
    component: SitzungBeitreten
  },

  {
    path: '/sitzung/funk',
    name: 'SitzungFunk',
    component: Funkgeraet,
    props: { mode: 'sitzung' },
    beforeEnter: nurInSitzung('funk')
  },

  {
    path: '/sitzung/sprechregeln',
    name: 'SitzungSprechregeln',
    component: Sprechregeln,
    props: { sitzung: true },
    beforeEnter: nurInSitzung('sprechregeln')
  },

  {
    path: '/sitzung/leiten',
    name: 'SitzungLeiten',
    component: SitzungLeiten
  },

  {
    path: '/training',
    name: 'Training',
    component: Training
  },

  {
    path: '/sprechregeln',
    name: 'sprechregeln',
    component: Sprechregeln
  },

  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
